import React from 'react';
import { Link } from 'gatsby';
import Image from 'gatsby-image';
import styled from 'styled-components';

import { bpMaxXXS, bpMaxXS, bpMaxSM, bpMaxLG } from '../utils/breakpoints';

const Container = styled.article`
	${bpMaxLG} {
		max-width: 190px;
	}

	${bpMaxSM} {
		max-width: 180px;
	}

	${bpMaxXS} {
		max-width: 170px;
	}

	${bpMaxXXS} {
		max-width: 140px;
	}

	max-width: 215px;

	a {
		color: var(--color-text);
	}

	h4 {
		transition: color 200ms ease 0ms;
	}

	a:hover {
		h4 {
			color: var(--color-primary);
			transition: color 200ms ease 150ms !important;
		}
		.book-cover {
			transform: scale(1.05);
			transition: all 300ms ease 0s !important;
			box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
		}
	}

	.book-cover {
		/* width: 180px; */
		transition: all 300ms ease 150ms !important;
		box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
			0 4px 6px -2px rgba(0, 0, 0, 0.05);
	}

	p.author {
		line-height: 18px;
		color: var(--color-gray-700);
		font-family: var(--font-heading);
	}

	p.excerpt {
		line-height: 26px;
		color: var(--color-gray-600);
	}
`;

const BookPreview = ({ book, childItemClass }) => {
	const {
		// slug,
		// date,
		title,
		author,
		cover,
		excerpt,
		// subTitle,
		// readingStatus,
	} = book.node.frontmatter;

	const content = (
		<>
			{cover.childImageSharp.fluid ? (
				<Image
					alt={title}
					className="book-cover rounded"
					fluid={cover.childImageSharp.fluid}
				/>
			) : (
				<img
					alt={title}
					className="book-cover rounded"
					src={cover.childImageSharp.fluid.src}
				/>
			)}
			<h4 className="text-sm xs:text-base sm:text-lg md:text-xl mt-4 mb-1">
				{title}
			</h4>
			<p className="text-xs sm:text-base mb-2 author">
				by <strong>{author}</strong>
			</p>
		</>
	);

	return (
		<Container className={`mb-8 md:mb-10 ${childItemClass}`}>
			{/* {readingStatus === 'read' ? (
				<Link aria-label={`View ${title}`} to={slug}>
					{content}
				</Link>
			) : (
				content
			)} */}
			{content}
			<p className="text-xs sm:text-sm excerpt">{excerpt}</p>
		</Container>
	);
};

export default BookPreview;
